<template>
    <div class="screensaver">
        <div class="page-top">
            <div class="logo" @click="goto('/')">
                <div class="picbox">
                    <div class="pic" style="background-image: url(/img/logo.png)"></div>
                </div>
            </div>
        </div>
        <div class="mainbox" style="background-image: url(/img/screensaver_bg.png)">
            <div class="top-con">
                <div class="titlebox">
                    <div class="atitle">悦心亭</div>
                    <div class="btitles">
                        <div class="btitle">悦己</div>
                        <div class="btitle">悦人</div>
                        <div class="btitle">悦心</div>
                    </div>
                    <div class="introduce">普陀悦心亭是上海市普陀区精神卫生中心发起建设的包含AI心理健康问询、线上测评、心理调适、认知训练、心理科普、专家与预约指引、心理社区网点查询、心理咨询热线一键拨打的智能一体化社区心理健康推广及援助平台。</div>
                </div>
                <div class="btns">
                    <button class="btn" @click="goto('/index')">进入主页</button>
                    <button class="btn" @click="goto('/about')">关于悦心亭</button>
                </div>
            </div>
            <div class="mid-con"></div>
            <div class="bottom-con">
                <div class="items">
                    <div class="titlebox">
                        <div class="atitle">心理热线</div>
                        <div class="btitle">如果您遇到任何心理问题需要咨询或得到建议，欢迎拨打免费心理咨询热线</div>
                        <div class="txt">
                            <a class="phonetitle">
                                <div class="picbox">
                                    <div class="pic" style="background-image: url(/img/screensaver_phone.png)"></div>
                                </div>
                                <span>上海市心理热线：021-962525&nbsp;&nbsp;&nbsp;&nbsp;全国心理热线：12356</span>
                            </a>
                            <div class="addresstitles">
                                <div class="addresstitle" @click="openMap(base.mapLink)">
                                    <div class="picbox">
                                        <div class="pic" style="background-image: url(/img/screensaver_location.png)"></div>
                                    </div>
                                    <span>上海市普陀区平利路57号（普陀区甘泉街道社区卫生服务中心东侧）</span>
                                </div>
                                <div class="addresstitle">
                                    <div class="picbox">
                                        <div class="pic" style="background-image: url(/img/screensaver_location.png)"></div>
                                    </div>
                                    <span>上海市普陀区精神卫生中心桃浦院区绿杨路658弄160支弄68号</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="moreitems">
                        <div class="more" @click="goto('/contact')">
                            <span>联系我们  →</span>
                        </div>
                        <div class="more" @click="openGuide(base.guideLink)">
                            <span>新手指导  →</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <iframe src="base.mapLink" frameborder="0" width="100%" height="600px"></iframe> -->
        </div>
        <el-dialog
            title="导航"
            v-model="dialogVisible"
            width="80%"
            height="100%"
            >
            <iframe id="reportFrame" frameborder="0" width="100%" height="600px"></iframe>
        </el-dialog>
        <el-dialog
            title="新手指导"
            v-model="guideDialogVisible"
            class="guide-dialog"
            >
            <iframe id="guideFrame" class="guide-iframe" frameborder="0" allowfullscreen="true" width="100%" scrolling="no"></iframe>
        </el-dialog>
    </div>
</template>

<script>
import { getBase, getWebrtcParams } from "@/js/request";
import { fa } from "element-plus/es/locales.mjs";
export default {
    name: 'Screensaver',
    components: {

    },
    data() {
        return {
            base: {},
            dialogVisible: true,
            guideDialogVisible: true,
        }
    },
    methods: {
        goto(adress, cate) {
            this.$router.push({path: adress, query: cate});
        },
        openMap(mapUrl) {
            this.dialogVisible = true;
            document.getElementById("reportFrame").src = mapUrl;
        },
        openGuide(guideMovieUrl) {
            this.guideDialogVisible = true;
            document.getElementById("guideFrame").src = guideMovieUrl;
        }
    },
    mounted() {
        let urlParams = new URLSearchParams(window.location.search);
        let logout = urlParams.get("logout");
        if (logout === "1") {
            this.$cookies.remove("token");
            
            // 删除掉 logout 参数，保留其他的
            urlParams.delete("logout");
            let newSearch = urlParams.toString();
            let newUrl =
                window.location.origin +
                (newSearch ? "?" + newSearch : "") +
                window.location.hash;

            window.history.replaceState({}, "", newUrl);
        }

        console.log("window.location.href=", window.location.href);
        console.log("webrtcId0", this.$route.query.webrtcId);
        console.log("webrtcIndex0", this.$route.query.index);
        if(this.$route.query.webrtcId != null && this.$route.query.webrtcId != undefined){
            window.localStorage.setItem('webrtcId', this.$route.query.webrtcId); 
        }
        if(this.$route.query.index != null && this.$route.query.index !=undefined){
            window.localStorage.setItem('webrtcIndex', this.$route.query.index); 
        }
        const webrtcId = window.localStorage.getItem('webrtcId');
        let webrtcIndex = window.localStorage.getItem('webrtcIndex');
        if(webrtcId != null && webrtcId != undefined && webrtcId != "" &&
            webrtcIndex != null && webrtcIndex != undefined && webrtcIndex != ""){
            console.log("webrtcIndex2", webrtcIndex);
            webrtcIndex = webrtcIndex.split("?")[0];
            console.log("webrtcIndex3", webrtcIndex);
            
            window.localStorage.setItem('currentWebrtcId', webrtcId);
        }
        this.dialogVisible = false;
        this.guideDialogVisible = false;
        this.$root.hideRight();
        getBase().then(res => {
            this.base = res.data;
        });
    }
}
</script>

<style lang="scss">
.screensaver {
    .guide-dialog .el-dialog__body {
        padding: 0;                         /* 去掉默认 padding */
        height: 55vh;        /* 对话框内容区的高度（减去标题/边距） */
    }
    .guide-iframe {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
    }
    .page-top {
        padding-left: 30px;
        height: 110px;
        background: rgba(255,255,255,0.5);
        border-radius: 0px 0px 0px 0px;
        .logo {     
            @include sys-picbox(438px, 110px);
            display: flex;
            align-items: center;
            cursor: pointer;
        }
    }
    .mainbox {
        width: 98%;
        height: calc(100% - 130px);
        background: rgba(255,255,255,0.01);
        border-radius: 24px 24px 24px 24px;
        position: fixed;
        top: calc(50% + 130px);
        left: 50%;
        transform: translate(-50%, calc(-50% - 75px));
        display: flex;
        flex-direction: column; 
        .top-con, .bottom-con {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .top-con {
            flex: 1;
            .titlebox {
                text-align: center;
                .atitle {
                    @include sys-text-hide(1);
                    @include sys-font(140px, #3F65E0);
                    font-family: 'FZZhengHeiS-DB-GB-Regular';
                    font-weight: 'Regular';
                }
                .btitles{
                    display: flex;
                    justify-content: center;  // 让子元素在水平方向居中
                    align-items: center;      // 让子元素在上下方向居中
                    .btitle {
                        background: #BCDDFF;
                        border-radius: 50px 50px 50px 50px;
                        width: 160px;
                        height: 70px;
                        margin-left: 15px;
                        &:first-child {
                            margin-left: 0; // 第一个不留空
                        }
                        @include sys-text-hide(1);
                        @include sys-font(40px, #3F65E0);
                        font-family: 'PingFangSC-Regular';
                        font-weight: 'Regular';
                    }
                    margin-bottom: 15px;
                }
                .introduce {
                    max-width: 1440px!important; // 不超过 166px
                    margin: 0 auto;   // 在父容器里居中
                    @include sys-text-hide(3);
                    @include sys-font(26px, #333333);
                    font-family: 'PingFangSC-Regular';
                    font-weight: 'Regular';
                }
                // margin-bottom: 20px;
            }
            .btns {
                display: flex;
                justify-content: center;  // 让子元素在水平方向居中
                align-items: center;      // 让子元素在上下方向居中
                .btn {
                    border-radius: 24px 24px 24px 24px;
                    border: 2px solid #3F65E0;
                    width: 210px;
                    height: 80px;
                    @include sys-font(30px, #3F65E0);
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 500;
                    line-height: 48px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                    box-sizing: border-box;
                    background: transparent;
                    &:first-child {
                        @include sys-font(30px, #fff);
                        background: linear-gradient( 133deg, #9C9AFD 0%, #00A9FD 100%);
                        margin-right: 20px;
                    }
                }
            }
        }
        .mid-con {
            border: 1px solid rgba(63,101,224,0.24);
            margin: 20px auto 0;
            width: 90%;
        }
        .bottom-con {
            padding: 10px 5%;
            .titlebox {
                width: calc(100% - 200px);
                .atitle {
                    @include sys-text-hide(1);
                    @include sys-font(34px, #333333, bold);
                    font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                    margin-bottom: 10px;
                }
                .btitle {
                    @include sys-text-hide(3);
                    @include sys-font(20px, #333);
                    margin-bottom: 10px;
                }
                .txt {
                    @include sys-picbox(18px, 20px);
                    .picbox {
                        margin-right: 20px;
                        flex: none;
                    }
                    .phonetitle, .addresstitle {
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;
                        letter-spacing: 1px;
                        span {
                            @include sys-text-hide(1);
                            @include sys-font(26px, #999999);
                            font-family: PingFangSC, PingFang SC;
                            font-weight: 500;
                            text-align: left;
                            font-style: normal;
                            text-transform: none;
                        }
                    }
                    // .addresstitles {
                    //     display: flex;
                    // }
                }
            }
            .items, .moreitems {
                display: flex;
            }
            .moreitems {
                width: 330px;
                display: flex;
                flex-direction: column; 
            }
            .more {
                width: 330px;
                background: linear-gradient( 136deg, #4DCCCA 0%, #17B9C2 100%);
                border-radius: 12px 12px 12px 12px;

                @include sys-font(20px, #FFFFFF);
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                line-height: 80px;
                text-align: center;
                font-style: normal;
                text-transform: none;
                margin-top: 10px;
                margin-bottom: 20px;
                &:first-child {
                    margin-top: 30px;
                    margin-bottom: 10px;
                    background: linear-gradient( 180deg, #E8B2BE 0%, #DC7087 100%);
                }
            }
        }
    }

    @media screen and (min-height: 1080px){
        .mainbox{
            .top-con {
                .titlebox {
                    .btitles{
                        height: calc(10vh);
                    }
                    .introduce {
                        line-height: calc(10vh);
                    }
                }
            }
        }
    }
}
</style>